

























































































import DownloadDia from '@/components/DownLoadDia.vue'; // 下载弹框组件
import CardProduct from '@/components/CardProduct.vue';
import CardContainer from '@/components/CardContainer.vue';
import FilterTags from '@/components/FilterTags.vue';
import FilterCategory from '@/components/FilterCategory.vue';
import FilterFileType from '@/components/FilterFileType.vue';
import PanelFold from '@/components/PanelFold.vue';
import Vue from 'vue';
import * as api from '@/api';

export default Vue.extend({
    name: 'BrandDetail',
    components: {
        CardProduct,
        CardContainer,
        FilterTags,
        FilterCategory,
        FilterFileType,
        PanelFold,
        DownloadDia,
    },
    data() {
        return {
            dialogVisible: {
                show: false,
            },
            fileTypes: [],
            dataLoading: true,
            brandInfo: {} as api.Brand,
            productCards: [] as api.ProductCard[],
            curShowFilter: '' as '' | 'category' | 'file',
            filterCategoryData: [] as api.FilterCategory[],
            filterCategorySelected: [] as api.FilterCategory[],
            filterFileTypeData: [] as api.FilterFileType[],
            filterFileTypeSelected: [] as api.FilterFileType[],
            brandCount: 0,
            productCount: 0,
            categorySum: 0,
            sortField: 'name ASC, id DESC',
            sortFields: [
                {
                    label: '名称排序',
                    id: 'name ASC, id DESC',
                },
                {
                    label: '收藏数量',
                    id: 'collectedCount DESC, id DESC',
                },
                {
                    label: '更新时间',
                    id: 'releasedTime DESC',
                },
            ],
        };
    },
    watch: {
        async filterCategorySelected() {
            await this.fetchProductList();
        },
        async filterFileTypeSelected() {
            await this.fetchProductList();
        },
        async sortField() {
            await this.fetchProductList();
        },
    },
    async created() {
        const res = await api.getBrand({ id: parseInt(this.$route.params.id, 0) });
        if (!api.error(res)) {
            this.brandInfo = res.data;
        }
        const filterRes = await api.getBrandProductFilter({
            brandId: this.$route.params.id,
        });
        if (!api.error(filterRes)) {
            this.filterCategoryData = filterRes.data.categories;
            this.getCategorySum(this.filterCategoryData);
            this.filterFileTypeData = filterRes.data.fileTypes;
        }
        await this.fetchProductList();
    },
    methods: {
        getCategorySum(data) {
            data.forEach((e) => {
                if (e.children.length > 0) {
                    this.getCategorySum(e.children);
                } else {
                    this.categorySum += 1;
                }
            });
        },
        async downloadFile(item) {
            const fileTypes = await api.getFileTypes({ id: item.productId, pvId: item.pvId });
            if (!api.error(fileTypes)) {
                fileTypes.data.length === 0 && this.$message({ type: 'info', message: '暂无模型文件可供下载' });
                fileTypes.data.length > 0 && (this.fileTypes = fileTypes.data) && (this.dialogVisible.show = true);
            }
        },
        // 关注品牌
        async putUserBrand(data) {
            let res;
            if (data.isConcerned) {
                res = await api.deleteUserBrand([{ brandId: Number(this.$route.params.id) }]); // 取消品牌关注
                if (!api.error(res)) {
                    data.isConcerned = !data.isConcerned;
                    data.fansCount -= 1;
                } else if (res.status === 401) {
                    this.$store.dispatch('loginHelper', [{ handle: this.putUserBrand, arguments: data }]);
                }
            } else {
                res = await api.putUserBrand([{ brandId: Number(this.$route.params.id) }]); // 关注品牌
                if (!api.error(res)) {
                    data.isConcerned = !data.isConcerned;
                    data.fansCount += 1;
                } else if (res.status === 401) {
                    this.$store.dispatch('loginHelper', [{ handle: this.putUserBrand, arguments: data }]);
                }
            }
        },
        async fetchProductList() {
            const cntRes = await api.getProductListCount({
                brandIds: [parseInt(this.$route.params.id, 0)],
                categoryIds: this.filterCategorySelected.map((c) => c.id),
                fileTypeNames: this.filterFileTypeSelected.map((f) => f.name),
            });
            if (!api.error(cntRes)) {
                this.brandCount = cntRes.data.brandCount;
                this.productCount = cntRes.data.productCount;
            }
            this.dataLoading = true;
            const res1 = await api.getProductList({
                brandIds: [this.$route.params.id],
                categoryIds: this.filterCategorySelected.map((c) => c.id),
                maxResultCount: 40,
                fileTypeNames: this.filterFileTypeSelected.map((f) => f.name),
                sorting: this.sortField,
            });
            if (!api.error(res1)) {
                this.productCards = res1.data.items;
            }
            this.dataLoading = false;
        },
        clearSelected() {
            this.filterCategorySelected = [];
            this.filterFileTypeSelected = [];
        },
        async loadMore() {
            this.dataLoading = true;
            const res = await api.getProductList({
                brandIds: [parseInt(this.$route.params.id, 0)],
                categoryIds: this.filterCategorySelected.map((c) => c.id),
                maxResultCount: 40,
                fileTypeNames: this.filterFileTypeSelected.map((f) => f.name),
                skipCount: this.productCards.length,
            });
            if (!api.error(res)) {
                this.productCards = [...this.productCards, ...res.data.items];
            }
            this.dataLoading = false;
        },
    },
});
